import { render } from "./CosmoAlarms.vue?vue&type=template&id=bde76718&scoped=true"
import script from "./CosmoAlarms.vue?vue&type=script&lang=js"
export * from "./CosmoAlarms.vue?vue&type=script&lang=js"

import "./CosmoAlarms.vue?vue&type=style&index=0&id=bde76718&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde76718"]])

export default __exports__